import { render, staticRenderFns } from "./TransferToClient.vue?vue&type=template&id=5860375e"
import script from "./TransferToClient.vue?vue&type=script&lang=js"
export * from "./TransferToClient.vue?vue&type=script&lang=js"
import style0 from "./TransferToClient.vue?vue&type=style&index=0&id=5860375e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports